const getters = {
  crumbsCont: state => state.crumbs.crumbsCont,
  // token: state => {
  //   reutrn state.crumbs.token = localStorage.getItem("token");
  // },
  token: state => state.crumbs.token,
  app_id: state => state.crumbs.app_id,
  merch_id: state => state.crumbs.merch_id,
  emp_id: state => state.crumbs.emp_id,
  status: state => state.crumbs.status,
  publicData: state => state.crumbs.publicData,
  pageLimit: state => state.crumbs.pageLimit,
  inviteForm: state => state.crumbs.inviteForm,
  lotteryfrom: state => state.lottery.lotteryfrom,
  show_data: state => state.shop_car.show_data,
  newData: state => state.crumbs.newData,
};
export default getters;
